// src/config.js
import configData from './config.json';

const actor = process.env.REACT_APP_ACTOR;
const env = process.env.REACT_APP_ENV || 'stagenet';
const config = configData[env];

config.DAPP_URL = config.DAPP_URL[actor || 'user'];

export default config;